export const colors = {
  primary: "#7DE5ED",
  secondary: "#ff5236",
};
